// extracted by mini-css-extract-plugin
export default {"up":"styles_up__aHcog","active":"styles_active__xbVTz"};